import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { TextField, Dialog, DialogTitle, DialogContent, FormControl, Container } from "@mui/material";
import Typography from '@mui/material/Typography';
import {  toast } from 'react-toastify';
import '../../assets/style/style.css';
import { useMaterialUIController, setReturnRequestContext } from "context";
import CircularProgress from '@mui/material/CircularProgress';
import { useParams, useNavigate } from 'react-router-dom';
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';
import MDBox from "components/MDBox";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout/index.js";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar/index.js";
import Config from "../../config.js";
import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import productNoImage from "../../assets/images/no-image.png";
import { handleErrors } from "common.js";
import ReturnSummary from "./components/ReturnSummary.js";
import ReturnItem from "./components/ReturnItem.js";

function View() {
  const [controller, dispatch]                          = useMaterialUIController();
  const { returnRequestContext }                        = controller;  
  const { returnId }                                    = useParams();  
  const navigate                                        = useNavigate();
  const { t }                                           = useTranslation();
  const BASE                                            = Config.BASE;
  const TOKEN                                           = window.localStorage.getItem('token'); 
  const [isLoading, setIsLoading]                       = useState(false);
  const [pageContent, setPageContent]                   = useState({});
  const [returnItem, setReturnItem]                     = useState({});

  useEffect(() => {
    loadReturnDetails();
  }, []);
  
  const handleReturnDetailsAPIResponse = (responseData) => {

      let returnInfo = responseData.data;

      setPageContent(returnInfo);

      const returnItemColumns  =  [
        { label: `${t("productId")}`, field: "productId" },
        { label: `${t("image")}`, field: "image" },
        { label: `${t("returnProductName")}`, field: "title" },        
        { label: `${t("sku")}`,field: "sku" },
        { label: `${t("quantity")}`, field: "quantity" },
        { label: `${t("unitPrice")}`, field: "price" },        
        { label: `${t("totalPrice")}`, field: "totalprice" }, 

      ];

      let returnRowsList = [];
      let productImage   = returnInfo.productImage ? returnInfo.productImage : productNoImage;
      let totalPrice     = returnInfo.quantity * returnInfo.price;
      let returnRows     = {
                              "productId"    : "#"+returnInfo.vendorProductId,
                              "image"        : <Box className="productImageBox"><img className="productImage" src={productImage} alt={returnInfo.productTitle}  /></Box>,
                              "title"        : <Box className="productTitleBox" title={returnInfo.productTitle}>{returnInfo.productTitle}</Box>,
                              "sku"          : returnInfo.sku ? returnInfo.sku : '-',
                              "quantity"     : returnInfo.quantity,
                              "price"        : `₹${returnInfo.price.toFixed(2)}`,
                              "totalprice"   : `₹${totalPrice.toFixed(2)}`,
                           };

          returnRowsList.push(returnRows);

      setReturnItem({ returnItemColumns, returnRowsList });
  };


  const loadReturnDetails = () => {
    setIsLoading(true);
    axios({      
      url     : BASE+"api/return/view/"+returnId,
      method  : "GET",
      headers : {
        Authorization   : `Bearer ${TOKEN}`,
        function        : Config.FUNCTION_KEY
      },        
    })
      .then(function (response) 
        {      
            const responseData           = response.data;
            const responseDataStatusCode = responseData.status;
            const responseMessage        = responseData.message;
            const responseStatusCode     = response.status;

            if(responseStatusCode === 200)
            {
                setIsLoading(false);
                if(responseDataStatusCode === 0)
                {
                    if(responseMessage)
                    toast.error(t(responseMessage));
           
                    const redirectTimeout = setTimeout(() => {          
                      clearTimeout(redirectTimeout);          
                      navigate(`/returns/list`);        
                    }, 3000);
                }
                else if(responseDataStatusCode === 1 && responseData && responseData.data)
                handleReturnDetailsAPIResponse(responseData);
            }        
            else 
            {
              toast.error(t('An unexpected error occurred while communicating with server'));
              return;            
            }     
        }).catch(function (error) { 
          setIsLoading(false);
          handleErrors(error, t, navigate);
        });
  }
   


  return (
    <DashboardLayout>
      {Object.keys(pageContent).length > 0 ?
        <>
        <DashboardNavbar pageTitle={t('orderReturn')+' #'+pageContent.orderNumber} pageSubTitle={t('detailsAboutOrderReturn')}/>
        <MDBox my={3}>
          <Grid container spacing={2} my={1}>
              {isLoading ?  
                <Grid item xs={12}>
                  <Box className='circularLoadingCommonOuter'>
                      <CircularProgress size={30} className='circularLoadingCommon' />
                  </Box>
                </Grid>
              : <></>}

              <Grid item xs={12}>
                <Card mb={2} variant="outlined">
                  <CardContent>
                    <Grid container spacing={0} mt={1}>
                      <Grid item sm={6} xs={12} my={2}>
                        <Typography variant="h6" color="text.secondary">
                          {t('orderReturnDetails')}
                        </Typography>
                        <Typography sx={{ fontSize: 14 }} component="div">
                          {t('detailsAboutOrderReturn')}
                        </Typography>
                      </Grid>
                  
                    </Grid>


                    <ReturnSummary 
                      returnID    = {returnId} 
                      pageContent = {pageContent} 
                      setIsLoading={setIsLoading}
                    />  

                  </CardContent>
                </Card>
              </Grid>
              
              {Object.keys(returnItem).length > 0 ?
                <ReturnItem 
                    returnID   = {returnId} 
                    returnItem = {returnItem} 
                /> 
              : null}
              
           
          </Grid>
        </MDBox>
        </>         
      : <></>}        
      </DashboardLayout>
  );
}
export default View;
